import { HttpInjector } from '@/cowboy/http/HttpInjector'
import { CatalogResponse } from '@/cowboy/catalog/object/CatalogResponse'

export class CatalogApi extends HttpInjector {
  /**
   * Fetches the Catalog for the current Reward Link
   * @return {Promise<CatalogResponse>}
   */
  static async fetchCatalog () {
    const response = await this.$http.get(
      `/sv/${this.codeVersion.requestCode}/catalog?urlVersion=${this.codeVersion.urlVersion}`
    )
    return this.cast(response.data, CatalogResponse)
  }

  /**
   * Fetches the Catalog for the current Reward Link
   * @return {Promise<CatalogResponse>}
   */
  static async fetchCatalogNew () {
    const response = await this.$http.get(
      `/sv/catalog?urlVersion=${this.codeVersion.urlVersion}&requestCode=${this.codeVersion.requestCode}`
    )
    return this.cast(response.data, CatalogResponse)
  }
}
